"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M12.002 16.9999c1.3913-.0008 2.6868-.4518 3.632-1.2266l-1.2679-1.5467c-.5553.4551-1.3919.7729-2.3661.7733-.9741-.0004-1.8108-.3182-2.366-.7733l-1.268 1.5467c.9453.7748 2.2431 1.2258 3.6344 1.2266h.0016zM11 9.5c0 .8284-.6716 1.5-1.5 1.5S8 10.3284 8 9.5 8.6716 8 9.5 8s1.5.6716 1.5 1.5zm3.5 1.5c.8284 0 1.5-.6716 1.5-1.5S15.3284 8 14.5 8 13 8.6716 13 9.5s.6716 1.5 1.5 1.5z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12c0 4.9706-4.0294 9-9 9s-9-4.0294-9-9 4.0294-9 9-9 9 4.0294 9 9zm-2 0c0 3.866-3.134 7-7 7s-7-3.134-7-7 3.134-7 7-7 7 3.134 7 7z"
  })];
};

exports.default = _default;